import React from 'react';

import { Redirect } from 'react-router-dom';

export default function AppRedirect({ redirectPath }) {
  return <Redirect push to={redirectPath} />;
}
